import { ChangeDetectionStrategy, Component, Input, OnInit, inject } from '@angular/core';
import { IDynamicElement } from '@sirius/common';

import { TrackingCommerceSnowplowService } from 'commerce/services';
import { ProductHeaderCommerceWrapper } from 'commerce/models';
import { ProductHeaderCommerceComponent } from '../product-header-commerce/product-header-commerce.component';

@Component({
    selector: 'commerce-product-header-commerce-wrapper',
    templateUrl: './product-header-commerce-wrapper.component.html',
    styleUrls: [],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ProductHeaderCommerceComponent]
})
export class ProductHeaderCommerceWrapperComponent implements IDynamicElement, OnInit {
    private _trackingCommerceSnowplowService = inject(TrackingCommerceSnowplowService);

    @Input()
    config!: ProductHeaderCommerceWrapper;


    ngOnInit(): void {
        this.trackProductView();
    }

    private trackProductView() {
        this._trackingCommerceSnowplowService.trackProductView({
            product: this.config.productTrackingObject,
        });
    }
}
